import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: () => [...dashboardKeys.all, 'stats'] as const,
};

/**
 * Hook to fetch aggregated dashboard statistics
 * GET /api/Dashboard
 */
export const useDashboardQuery = () => {
  return useQuery({
    queryKey: dashboardKeys.stats(),
    queryFn: () => apiClient.getDashboardStats(),
    gcTime: 5 * 60 * 1000,
  });
};
